import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=28d5db22&scoped=true&"
import script from "./CurrencyField.vue?vue&type=script&lang=ts&"
export * from "./CurrencyField.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencyField.vue?vue&type=style&index=0&id=28d5db22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d5db22",
  null
  
)

export default component.exports